import { render, staticRenderFns } from "./GiftContent.vue?vue&type=template&id=1dd03437&"
import script from "./GiftContent.vue?vue&type=script&lang=js&"
export * from "./GiftContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports